"use strict";function nfcStop$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.nfcStop$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.nfc.nfcStop";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.3.9"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.3.9"},_a)),exports.nfcStop$=nfcStop$,exports.default=nfcStop$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/nfc/nfcStop.js
// module id = 1065
// module chunks = 106